import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // for navigation
import { Link } from "react-router-dom";
import axios from "../api/axios"; // assuming you have an axios instance set up

export default function Header() {
    const [query, setQuery] = useState("");
    const [category, setCategory] = useState("All Categories");
    const [cartItems, setCartItems] = useState([]);
    const [total, setTotal] = useState(0);
    const [categories, setCategories] = useState([]);
    const [openDropdown, setOpenDropdown] = useState(null); // track open dropdown
    const token = localStorage.getItem("token");
    const [products, setProducts] = useState([]);
    const [companyInfo, setCompanyInfo] = useState({}); // New state for company info

    useEffect(() => {
      fetchCategories();
      fetchCompanyInfo();
    }, []);

      const fetchCategories = async () => {
    try {
      const res = await axios.get("/categories");
      setCategories(res.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };
      const fetchCompanyInfo = async () => {
    try {
      const res = await axios.get("/company-info");
      setCompanyInfo(res.data);
    } catch (error) {
      console.error("Error fetching company info:", error);
    }
  };
console.log(companyInfo);
  const navigate = useNavigate(); // react-router-dom v6
const handleSubmit = (e) => {
  e.preventDefault();

  if (query.trim() === "") {
    navigate("/"); // Redirect to home if query is empty
    return;
  }

  const queryString = `?q=${encodeURIComponent(query)}&cat=${encodeURIComponent(category)}`;

  navigate(`/search${queryString}`);
};  

const handleCheckout = () => {
  navigate("/checkuser");
};

useEffect(() => {
  const fetchCategories = async () => {
    try {
      const res = await axios.get("/products");
      setProducts(res.data);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  fetchCategories();
}, []);

useEffect(() => {
const fetchCart = async () => {
  const token = localStorage.getItem("token");

  if (token) {
    // ✅ Logged-in user cart (from backend)
    try {
      const res = await axios.get("/cart", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setCartItems(res.data);

      const sum = res.data.reduce(
        (acc, item) => acc + item.price * item.quantity,
        0
      );
      setTotal(sum);
    } catch (error) {
      console.error("Failed to fetch cart", error);
    }
  } else {
    // ✅ Guest user cart (from localStorage)
    const guestCart = JSON.parse(localStorage.getItem("cart")) || [];
    setCartItems(guestCart);

    const sum = guestCart.reduce(
      (acc, item) => acc + item.price * item.quantity,
      0
    );
    setTotal(sum);
  }
};


  fetchCart();
}, []);

console.log(cartItems, "cartItems");

const handleRemoveFromCart = async (id) => {

  if (token) {
    // ✅ Logged-in user -> remove from backend
    try {
      await axios.delete(`https://cartbackend.wsdstech.com/api/cart/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Update state
      setCartItems((prevItems) => prevItems.filter((item) => item.id !== id));
      window.location.reload();
    } catch (err) {
      console.error("Failed to remove item", err);
    }
  } else {
    // ✅ Guest user -> remove from localStorage
    const guestCart = JSON.parse(localStorage.getItem("cart")) || [];

    const updatedCart = guestCart.filter((item) => item.product_id !== id);

    localStorage.setItem("cart", JSON.stringify(updatedCart));
    setCartItems(updatedCart);
    window.location.reload();
  }
};


  return (
    <>
<div
      className="offcanvas offcanvas-end"
      data-bs-scroll="true"
      tabIndex="-1"
      id="offcanvasCart"
      aria-labelledby="offcanvasCartLabel"
    >
      <div className="offcanvas-header border-bottom justify-content-between">
        <h5 id="offcanvasCartLabel" className="mb-0">🛒 Your Cart</h5>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
<div className="offcanvas-body">
  
  {cartItems.length === 0 ? (
    <p className="text-center text-muted mt-4">Your cart is empty.</p>
  ) : (
    <>
<ul className="list-group mb-3">
  {cartItems.map((item) => {
    const isLoggedIn = !!token; // convert token to boolean
    const productName = isLoggedIn ? item.product.name : item.name;
    const productPrice = isLoggedIn ? parseInt(item.price) : item.price;
    const productId = isLoggedIn ? item.id : item.product_id;

    return (
      <li
        key={item.id}
        className="list-group-item d-flex justify-content-between align-items-center"
      >
        <div>
          <h6 className="my-0">{productName}</h6>
          <small className="text-muted">
            {item.quantity} × ₹{productPrice}
          </small>
        </div>
        <div>
          <img src={!isLoggedIn ? products.find(item => item.id === productId)?.image_url : item.product.image_url} alt="" style={{width: "100px", height: "100px", objectFit: "cover"}} />
        </div>

        <div className="d-flex align-items-center">
          <span className="text-muted me-3">
            ₹{item.quantity * productPrice}
          </span>

          {/* Remove button */}
          <button
            className="btn btn-sm btn-outline-danger"
            onClick={() => handleRemoveFromCart(productId)}
          >
            ✕
          </button>
        </div>
      </li>
    );
  })}

  <li className="list-group-item d-flex justify-content-between">
    <strong>Total</strong>
    <strong>₹{total}</strong>
  </li>
</ul>


      <button
        className="btn btn-primary w-100"
        onClick={handleCheckout}
        data-bs-dismiss="offcanvas"
      >
        Continue to Checkout
      </button>
    </>
  )}
</div>

    </div>
        <div className="offcanvas offcanvas-end" data-bs-scroll="true" tabIndex="-1" id="offcanvasSearch" aria-labelledby="Search">
      <div className="offcanvas-header justify-content-center">
        <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>
      <div className="offcanvas-body">
        <div className="order-md-last">
          <h4 className="d-flex justify-content-between align-items-center mb-3">
            <span className="text-primary">Search</span>
          </h4>
         <form role="search" onSubmit={handleSubmit} className="d-flex mt-3 gap-0">
      <input
        className="form-control rounded-start rounded-0 bg-light"
        type="search"
        name="q"
        placeholder="What are you looking for?"
        aria-label="What are you looking for?"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        required
      />
      <button
        className="btn btn-dark rounded-end rounded-0"
        type="submit"
        data-bs-dismiss="offcanvas"
      >
        Search
      </button>
    </form>
        </div>
      </div>
    </div>
    <header>
      <div className="container-fluid">
        <div className="row border-bottom">
          
          <div className="col-sm-4 col-lg-3 text-center text-sm-start">
            <div className="main-logo">
              <Link to="/">
                <img src={companyInfo.logo_url || "/images/logo1.png"} alt="logo" className="img-fluid" style={{ maxHeight: "70px" }}/>
              </Link>
            </div>
          </div>
          
     <div className="col-sm-6 offset-sm-2 offset-md-0 col-lg-5 d-none d-lg-block">
      <div className="search-bar row bg-light p-2 my-2 rounded-4">
        <div className="col-md-4 d-none d-md-block">
          <select
            className="form-select border-0 bg-transparent"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            <option value="All Categories">All Categories</option>
            {categories.map((cat) => (!cat.parent_id ? (
              <option key={cat.id} value={cat.id}>
                {cat.name}
              </option>
            ) : null))}
          </select>
        </div>
        <div className="col-11 col-md-7">
          <form onSubmit={handleSubmit} className="text-center">
            <div className="input-group">
              <input
                type="text"
                name="q"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                className="form-control border-0 bg-transparent"
                placeholder="Search for more than 20,000 products"
              />
            </div>
          </form>
        </div>
        <div className="col-1 d-flex align-items-center">
          <button onClick={handleSubmit} className="btn p-0 border-0 bg-transparent">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path fill="currentColor" d="M21.71 20.29L18 16.61A9 9 0 1 0 16.61 18l3.68 3.68a1 1 0 0 0 1.42 0a1 1 0 0 0 0-1.39ZM11 18a7 7 0 1 1 7-7a7 7 0 0 1-7 7Z"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
          
          <div className="col-sm-8 col-lg-4 d-flex justify-content-end gap-5 align-items-center mt-4 mt-sm-0 justify-content-center justify-content-sm-end">
            <div className="support-box text-end d-none d-xl-block">
              <span className="fs-6 text-muted">For Support?</span>
              <h6 className="mb-0">{companyInfo.contact_no || "+980-34984089"}</h6>
            </div>

            <ul className="d-flex justify-content-end list-unstyled m-0">
              <li>
                <Link to="/profile" className="rounded-circle bg-light p-2 mx-1">
                  <i className="fa fa-solid fa-user"></i>
                </Link>
              </li>
              <li>
                <Link to="/wishlist" className="rounded-circle bg-light p-2 mx-1">
                  <i className="fa fa-solid fa-heart"></i>
                </Link>
              </li>
              <li className="d-lg-none">
                <Link to="#" className="rounded-circle bg-light p-2 mx-1" data-bs-toggle="offcanvas" data-bs-target="#offcanvasCart" aria-controls="offcanvasCart">
                  <i className="fa fa-solid fa-shopping-cart"></i>
                </Link>
              </li>
              {/* <li className="d-lg-none">
                <Link to="#" className="rounded-circle bg-light p-2 mx-1" data-bs-toggle="offcanvas" data-bs-target="#offcanvasSearch" aria-controls="offcanvasSearch">
                  <i className="fa fa-solid fa-magnifying-glass"></i>
                </Link>
              </li> */}
            </ul>

            <div className="cart text-end d-none d-lg-block dropdown">
              <button className="border-0 bg-transparent d-flex flex-column gap-2 lh-1" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasCart" aria-controls="offcanvasCart">
                <span className="fs-6 text-muted dropdown-toggle">Your Cart</span>
                <span className="cart-total fs-5 fw-bold">₹{total}</span>
              </button>
            </div>
          </div>

        </div>
      </div>
      <div className="container-fluid">
        <div className="row">
          <div className="d-flex  align-items-center">
            <nav className="main-menu d-flex navbar navbar-expand-lg">
         <form role="search" onSubmit={handleSubmit} className="mobile-search mt-3 gap-0 w-75">
      <input
        className="form-control rounded-start rounded-0 bg-light"
        type="search"
        name="q"
        placeholder="What are you looking for?"
        aria-label="What are you looking for?"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
  
      />
      <button
        className="btn btn-dark rounded-end rounded-0"
        type="submit"

      >
        Search
      </button>
    </form>
              <button className="navbar-toggler" style={{position: "relative", left: "0"}} type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar"
                aria-controls="offcanvasNavbar">
                <span className="navbar-toggler-icon"></span>
              </button>

              <div className="offcanvas offcanvas-end" tabIndex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">

                <div className="offcanvas-header justify-content-center">
                  <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>

                <div className="offcanvas-body">
              
                 
              
<ul className="navbar-nav justify-content-end menu-list list-unstyled d-flex gap-md-3 mb-0">
  {categories
    .filter((cat) => cat.parent_id === null) // only main categories
    .map((parent) => (
      <li
        key={parent.id}
        className={`nav-item dropdown ${openDropdown === parent.id ? "show" : ""}`}
        onMouseEnter={() => setOpenDropdown(parent.id)}
        onMouseLeave={() => setOpenDropdown(null)}
      >
        <Link
          to="#"
          className="nav-link dropdown-toggle"
          id={`dropdown-${parent.id}`}
          aria-expanded={openDropdown === parent.id}
          onClick={(e) => e.preventDefault()} // prevent redirect
        >
          {parent.name}
        </Link>

        {/* Subcategories */}
        <ul
          className={`dropdown-menu ${openDropdown === parent.id ? "show" : ""}`}
          aria-labelledby={`dropdown-${parent.id}`}
        >
          {categories
            .filter((sub) => sub.parent_id === parent.id) // only children of this parent
            .map((sub) => (
              <li key={sub.id}>
                <Link to={`/categories/${sub.id}`} className="dropdown-item">
                  {sub.name}
                </Link>
              </li>
            ))}
        </ul>
      </li>
    ))}

  <li className="nav-item">
    <Link to="/all-products" className="nav-link">Shop</Link>
  </li>
</ul>


                
                </div>

              </div>
            </nav>
          </div>
        </div>
      </div>
    </header>
      
    </>
  )
}
